




















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { GENDERS } from '@/settings/consts/patient';
import { toUpperCase } from '@/helpers/toUpperCase';

@Component
export default class UiGenderPicker extends Vue {
  @Prop(String)
  public label!: string;
  @Prop(String)
  public value!: string;
  @Prop()
  public suffix?: string;
  @Prop()
  public placeholder?: string;
  @Prop()
  public height?: string;
  @Prop()
  public singleLine?: boolean;
  @Prop()
  public outline?: boolean;
  @Prop()
  public required?: boolean;
  @Prop()
  public hideDetails?: boolean;
  @Prop()
  public disabled?: boolean;
  @Prop()
  public rules?: any[];

  public attr = {
    suffix: '',
    label: 'Clientes',
    placeholder: '',
    height: '',
    singleLine: false,
    outline: false,
    hideDetails: false,
    required: false,
    rules: [],
  };

  public selectedSex: string = '';

  public genderList: any[] = [];

  @Watch('value', {immediate: true})
  public onValChanged(val: string): void {
    this.selectedSex = val;
  }

  public beforeMount(): void {
    this.attr.label = this.label || this.attr.label;
    this.attr.suffix = this.suffix || this.attr.suffix;
    this.attr.placeholder = this.placeholder || this.attr.placeholder;
    this.attr.height = this.height || this.attr.height;
    this.attr.singleLine =
      typeof this.singleLine !== 'undefined' || this.attr.singleLine;
    this.attr.outline =
      typeof this.outline !== 'undefined' || this.attr.outline;
    this.attr.hideDetails =
      typeof this.hideDetails !== 'undefined' || this.attr.hideDetails;
    this.attr.required =
      typeof this.required !== 'undefined' || this.attr.required;
    this.attr.rules = this.rules || this.attr.rules;

    this.getGenders();
  }

  public onChange(): void {
    this.$emit('input', this.selectedSex);
    this.$emit('change');
  }

  private getGenders(): void {
    const genders = GENDERS;
    for (const gender in genders) {
      if (genders.hasOwnProperty(gender)) {
        this.genderList.push({
          value: toUpperCase(gender),
          title: toUpperCase(genders[gender]),
        });
      }
    }
  }
}
